module.exports = __webpack_public_path__ + "img/map.2a7a7f72.png";